import { API_URL } from '../../utils/constants';

import request from '../request';

export default {
  get: async (id) => {
    return request(`${API_URL}/transport-pricings/${id}`, 'get');
  },
  update: async (id, values) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/transport-pricings/${id}`, 'put', body);
  },
  create: async (values) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/transport-pricings/`, 'post', body);
  },
  delete: async (id) => {
    return request(`${API_URL}/transport-pricings/${id}`, 'delete');
  },
};
